import { useState } from "preact/hooks";
/* 
demo functional component, turns out it does just work!
make sure the export isn't default, same as Widget/class components
*/
export function FunctionalWidget(props) {
	const [input, setInput] = useState("");
	const { foo } = props;

	return (
		<div>
			<p>Do you agree to the statement: "Preact hooks are awesome"?</p>
			<input value={input} onInput={(e) => setInput(e.target.value)} />
			{input && (
				<p>
					You entered: <strong>{input}</strong>
				</p>
			)}
			{foo && <p>props.foo: {props.foo}</p>}
		</div>
	);
}
